import { render, staticRenderFns } from "./tommSystem.vue?vue&type=template&id=04dd8568&scoped=true&"
import script from "./tommSystem.vue?vue&type=script&lang=js&"
export * from "./tommSystem.vue?vue&type=script&lang=js&"
import style0 from "./tommSystem.vue?vue&type=style&index=0&id=04dd8568&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd8568",
  null
  
)

export default component.exports